import React, { createContext, useContext, useEffect, useState } from "react";
import translations from "../i18n/translations";

const LangContext = createContext(null);

const VALID = ["ro", "en"];

const initialLang = () => {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get("lang") || "").toLowerCase();
    if (VALID.includes(q)) return q;
  }
  const stored = (typeof localStorage !== "undefined" && localStorage.getItem("corsa_lang")) || "ro";
  return VALID.includes(stored) ? stored : "ro";
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    localStorage.setItem("corsa_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // Re-read ?lang= on URL changes (popstate / pushstate manual)
  useEffect(() => {
    const onPop = () => {
      const params = new URLSearchParams(window.location.search);
      const q = (params.get("lang") || "").toLowerCase();
      if (VALID.includes(q) && q !== lang) setLang(q);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [lang]);

  const t = translations[lang] || translations.ro;

  const value = {
    lang,
    setLang,
    toggle: () => setLang(lang === "ro" ? "en" : "ro"),
    t,
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
};
